import React from 'react';
import './Style/ResumeAssessment.css';
import { useNavigate, useSearchParams } from "react-router-dom";
import bg from "./Image/blank_background.png";

const ResumeAssessment: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const reportNo = searchParams.get("ReportNo") || "0";
  const calledFrom = searchParams.get("CalledFrom") || "";
  const logo_class="md_logo_scale"

  // console.log("reportNo:", reportNo);
  // console.log("calledFrom:", calledFrom);

  const handleExitOrLogout = () => {
    navigate("/STUDENT/MSR/StudyRoom");
  };

  const handleResume = () => {
    const queryString = `?ReportNo=${encodeURIComponent(reportNo)}&CalledFrom=${encodeURIComponent(calledFrom)}`;
    // console.log("queryString:", queryString);
    navigate(`/MathsDoctor/Assessment/Assessment${queryString}`);
  };

  return (
     <div  style={{ backgroundImage: `url(${bg})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", position:"absolute",width:"100vw",height:"100vh" }}>
    <form id="Form">
      <div>
        <div id="resume_container">
          <button id="linkbtnLogout" className="sign_out" aria-label="Sign Out" onClick={handleExitOrLogout} />
          <a href="#" className="sign_out" style={{ display: 'none' }}></a>
          <div id="divLoggedName">Logged in as {sessionStorage.getItem("FName")}</div>
        </div>

        <div id="resume_content_box">
          <div id="resume_content">
            <div id="resume_text_box">
              <p className="resume_title">WELCOME BACK</p>
              <p className="resume_text">
                <br />
                You did not complete the assessment when you were last logged in.
                <br />
                <br />
                <span className="resume_orange">Would you like to resume the assessment now?</span>
                <br />
                <br />
              </p>

              <div id="middleband_div">
                <div className="button_div">
                  <button id="linkbtnExit" className="exit_btn" aria-label="Exit" onClick={handleExitOrLogout} />
                  <a href="#" className="exit_btn" style={{ display: 'none' }}></a>
                </div>

                <div id="bok_doorway"></div>

                <div className="button_div">
                  <button id="linkbtnResume" className="resume_btn" aria-label="Resume" onClick={handleResume} />
                  <a href="#" className="resume_btn" style={{ display: 'none' }}></a>
                </div>
              </div>

              <div id="bok_doorway2"></div>
              <div id="divLogoScale2"></div>
            </div>
          </div>
        </div>
           <div id="divLogo" className={logo_class} />

        <div id="divLogoScale"></div>
        <div id="ucLoadingScreen"></div>
      </div>
    </form>
    </div>
  );
};

export default ResumeAssessment;
